export default {"src":"/_next/static/media/image3.1ae7f3f4.svg","height":378,"width":379,"blurWidth":0,"blurHeight":0};